module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 3.17716","quantity":0.03177},{"color":"#9dc4b5","label":" 3.17716- 5.15023","quantity":0.0515},{"color":"#e6efc3","label":" 5.15023- 5.98148","quantity":0.05981},{"color":"#ffe89e","label":" 5.98148- 7.25885","quantity":0.07259},{"color":"#f5af7f","label":" 7.25885- 9.47949","quantity":0.09479},{"color":"#ed6d32","label":" 9.47949- 26.60876","quantity":0.26609}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_100_return_20.json
// module id = Mu49
// module chunks = 171